import * as React from 'react'

import { action, makeObservable, observable } from 'mobx'
import { classList, toggleClass } from 'react-classlist-helper'

import OpacityBackground from '~/client/src/desktop/components/OpacityBackground/OpacityBackground'

import ViewModeToggle from './components/ViewModeToggle/ViewModeToggle'
import HeaderBarStore from './HeaderBar.store'

import './HeaderBar.scss'

// localization: no display text to translate

export default class BaseHeaderBar<T> extends React.Component<T> {
  @observable protected isModalOpen: boolean = false
  protected store: HeaderBarStore = null

  public constructor(props: T) {
    super(props)
    makeObservable(this)
  }

  public render() {
    const { shouldShowOpacityBackground } = this.store

    const actionBar = this.renderActionBar()
    const secondRowBar = this.renderSecondRow()

    return (
      <div className="tw:flex tw:flex-col tw:relative tw:grow-0">
        <div
          className={classList({
            // header-bar: scoping hook for descendant selectors in Deliveries.scss, Logistics.scss, Attachments.scss, Materials.scss
            'header-bar tw:flex tw:items-center tw:flex-wrap tw:min-h-[65px] tw:justify-start tw:pb-2.5 tw:pt-[5px] tw:relative': true,
            'tw:border-0 tw:border-b tw:border-solid tw:border-border tw:px-6':
              !actionBar && !secondRowBar,
          })}
        >
          {this.isModalOpen && this.renderModal()}
          {this.renderLeftSection()}
          <div
            className={classList({
              'tw:flex tw:items-center tw:flex-1 tw:min-h-[50px] tw:justify-between tw:flex-wrap tw:min-w-[500px] tw:relative': true,
              'tw:px-6 tw:border-0 tw:border-b tw:border-solid tw:border-border':
                !!secondRowBar,
            })}
          >
            {this.renderCenterSection()}
            <div className="tw:flex tw:items-center tw:justify-end tw:h-full tw:grow-0">
              {this.renderRightSection()}
              {this.renderViewToggle()}
            </div>
          </div>
        </div>
        <div
          className={toggleClass(
            'tw:border-0 tw:border-b tw:border-solid tw:border-border',
            !!secondRowBar,
          )}
        >
          {secondRowBar}
        </div>
        <OpacityBackground isAnyPopupOpened={shouldShowOpacityBackground} />
        {actionBar}
      </div>
    )
  }

  @action.bound
  protected toggleModal() {
    this.isModalOpen = !this.isModalOpen
  }

  protected renderModal() {
    return <div />
  }

  protected renderViewToggle() {
    const { viewState, viewModes, setViewMode } = this.store
    return (
      <ViewModeToggle
        viewState={viewState}
        viewModes={viewModes}
        setViewMode={setViewMode}
      />
    )
  }

  protected renderLeftSection() {
    return <div />
  }

  protected renderCenterSection() {
    return <div />
  }

  protected renderRightSection() {
    return <div />
  }

  protected renderActionBar() {
    return this.props.children || null
  }

  protected renderSecondRow(): JSX.Element {
    return null
  }
}
